// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3BrnN","footer":"ModalCreateQualiphyProcedure_footer__rtpEB","additionData":"ModalCreateQualiphyProcedure_additionData__2E6D8"};